module.exports = __webpack_public_path__ + "fonts/nunito-sans-latin-600italic.875baa5.woff";